import { render } from "./VideoTile.vue?vue&type=template&id=deba13fa&scoped=true"
import script from "./VideoTile.vue?vue&type=script&lang=js"
export * from "./VideoTile.vue?vue&type=script&lang=js"

import "./VideoTile.vue?vue&type=style&index=0&id=deba13fa&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deba13fa"]])

export default __exports__